import React, { useMemo, useState } from 'react'
import { StreamData } from 'types/streamData'
import { DefaultMediaDisplayOptionStrings } from 'enums/DefaultMediaDisplayOption'
import MediaGrid, { MediaClickHandler } from './MediaGrid'
import MediaController from './MediaController'

interface MediaOptions {
  defaultDisplayOption: DefaultMediaDisplayOptionStrings | undefined
  onMediaClick?: MediaClickHandler
}

const useMedia = (streamData: StreamData, options: MediaOptions) => {
  const [isShowMedia, setIsShowMedia] = useState(
    () => options.defaultDisplayOption === 'EXPAND_ALL_MEDIA'
  )

  const memoizedMediaController = useMemo(
    () => <MediaController isShowMedia={isShowMedia} setIsShowMedia={setIsShowMedia} />,
    [isShowMedia, setIsShowMedia]
  )

  const memoizedMediaGrid = useMemo(
    () => (
      <MediaGrid
        display={isShowMedia}
        streamData={streamData}
        onMediaClick={options.onMediaClick}
      />
    ),
    [isShowMedia, streamData, options.onMediaClick]
  )

  return {
    mediaController: memoizedMediaController,
    mediaGrid: memoizedMediaGrid
  }
}

export default useMedia
